export function trimLeadingSlash(str: string): string {
    return str.replace(/^[\\/]/, '');
}
